const SkeletonLoader = () => {
  return (
    <div className="animate-pulse flex space-x-4 w-[240px] mb-2 h-[40px] bg-[#1F365E] rounded-[6px]" />
  );
};

export default SkeletonLoader;
